interface LogoStackProps {
  logos: { url: string; alt: string }[];
}

/**
 * Row of competitor logo chips; fewer show on small screens.
 * @param props - logos to stack, left to right
 * @returns the stack
 */
export default function LogoStack({ logos }: LogoStackProps) {
  return (
    <div className="flex items-center gap-2">
      {logos.map((logo, i) => (
        <span
          key={`${logo.url}-${i}`}
          className={`h-16 w-28 items-center justify-center overflow-hidden rounded-2xl border border-landing-primary bg-white px-3 py-2.5 shadow-[0_1px_3px_0_oklch(0.4_0.02_280/0.05)] ${
            i < 1 ? "flex" : i < 2 ? "hidden sm:flex" : "hidden md:flex"
          }`}
        >
          <img src={logo.url} alt={logo.alt} className="size-full object-contain" loading="lazy" />
        </span>
      ))}
    </div>
  );
}
